"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Handshake = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Handshake = function Handshake() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.735 2a.455.455 0 01.232.845l-.072.035-.278.104c-.583.228-1.285.607-1.285 1.743 0 4.257 3.461 4.68 4.707 4.478l4.5-.73 5.244 4.838c.403.334.66.843.66 1.414 0 1.004-.796 1.819-1.778 1.819a1.74 1.74 0 01-.907-.255l.013.105.005.15c0 1.004-.796 1.818-1.777 1.818a1.74 1.74 0 01-.908-.255l.013.105.006.15c0 1.004-.796 1.818-1.778 1.818a1.74 1.74 0 01-.908-.255l.013.106.006.149c0 1.004-.796 1.818-1.778 1.818a1.763 1.763 0 01-1.44-.751l-7.799-8.34h-.414a1 1 0 01-1-.999L0 3.001a1 1 0 01.882-.994L1 2h5.735zm8.375 0c.366 0 .706.11.988.3l4.345 2.427 2.308-.59a1 1 0 011.241.852l.007.117v8.621a1 1 0 01-.884.993l-.116.007h-.79c-.046-1.241-.481-1.894-1.022-2.474l-.11-.115-.73-.733a91.295 91.295 0 00-1.103-1.045l-.196-.183-3.938-3.635-5.304.86c-.077.018-.156.031-.236.04h-.013c-.075.009-.15.013-.225.013-1.228 0-2.222-1.018-2.222-2.273v-.455l7.276-2.574c.221-.098.466-.153.724-.153z",
    clipRule: "evenodd"
  });
};

exports.Handshake = Handshake;